import Directories from 'components/Directories'
import { PROVIDERS, RESULTS_TYPES } from 'utils/DirectoryParser'

const NanniesDirectories = (props) => (
  <Directories
    props={props}
    directoryLabel='Nannies'
    directoryProvider={PROVIDERS.NANNIES}
    directoryBasePath={PROVIDERS.NANNIES.profilesBasePath}
    directoryResultsType={RESULTS_TYPES.PROFILES}
  />
)

export default NanniesDirectories
